import { Dictionary } from "../../../../../types";
import { StoreFeature } from "../../../core/store/types";
import { HTMLEditorPlugin } from "../types";

export const plugins: StoreFeature<Dictionary<string, HTMLEditorPlugin>> = {}